export default __webpack_public_path__ + "static/media/PlainScone.47e7bb31.png";